import React from 'react';
import { FiFileText, FiExternalLink, FiCheckCircle } from 'react-icons/fi';
import { GiWheat, GiThreeLeaves, GiPlantRoots } from 'react-icons/gi';
import { FaLeaf } from 'react-icons/fa';
import Reveal from '../Reveal/Reveal';
import '../../styles/certification.css';

/* Certificate files in public/certificate/ */
const PDF = `${process.env.PUBLIC_URL}/certificate/organic-certificate.pdf`;
const PREVIEW = `${process.env.PUBLIC_URL}/certificate/certificate-preview.jpg`;

const DECOR = [
  { Icon: FaLeaf, cls: 't1' },
  { Icon: GiWheat, cls: 't2' },
  { Icon: GiThreeLeaves, cls: 't3' },
  { Icon: GiPlantRoots, cls: 't4' },
];

export default function Certification() {
  return (
    <section id="certification" className="section certification">
      <div className="certification__decor" aria-hidden="true">
        {DECOR.map(({ Icon, cls }) => (
          <Icon key={cls} className={`certification__leaf ${cls}`} />
        ))}
      </div>

      <div className="container">
        <Reveal className="section-head">
          <h2 className="section-title">Certified Organic</h2>
          <p className="section-subtitle">
            Our farm and produce are certified by the Government of Tamil Nadu —
            your assurance of genuinely natural, chemical-free farming.
          </p>
        </Reveal>

        <div className="certification__grid">
          <Reveal className="certification__doc">
            <a
              href={PDF}
              target="_blank"
              rel="noreferrer"
              className="certification__preview"
              aria-label="Open the organic certificate PDF"
            >
              <img
                src={PREVIEW}
                alt="Mahizh Natural Farming organic certificate"
                loading="lazy"
              />
              <span className="certification__preview-overlay">
                <FiFileText /> View full certificate
              </span>
            </a>
          </Reveal>

          <Reveal delay={1} className="certification__info">
            <span className="certification__badge">
              <FiCheckCircle /> TNOCD Certified
            </span>

            <p className="certification__text">
              Certified by the{' '}
              <strong>TamilNadu Organic Certification Department</strong> under
              India’s National Programme for Organic Production — your assurance
              that every harvest is genuinely natural and chemical-free.
            </p>

            <a
              href={PDF}
              className="btn btn-primary certification__view"
              target="_blank"
              rel="noreferrer"
            >
              View Certificate <FiExternalLink />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
